// The pages and menu entries every category has. Each route / menu entry may name the module that switches it on (see
// Helper/category.js); an entry without one is always there.
import AllCourses from "../../pages/Courses/AllCourses.js";
import CourseBuilder from "../../pages/Courses/CourseBuilder.js";
import Welcome from "../../pages/Welcome/Welcome.js";
import Billing from "../../pages/Billing/Billing.js";
import Meetings from "../../pages/Meetings/Meetings.js";
import MeetingLive from "../../pages/Meetings/MeetingLive.js";
import MeetingAttendance from "../../pages/Meetings/MeetingAttendance.js";
import AddItemGallery from "../../pages/Gallery/AddItem.js";
import Gallery from "../../pages/Gallery/Gallery.js";
import GalleryProjects from "../../pages/Gallery/GalleryProjects.js";
import Resources from "../../pages/Settings/Resources.js";
import AddNews from "../../pages/News/AddNews.js";
import Links from "../../pages/links/links.js";
import Notifications from "../../pages/notifications/notifications.js";
import Schedule from "../../pages/Schedule/Schedule.js";
import AllInbox from "../../pages/inbox/allInbox.js";
import EditInboxDetail from "../../pages/inbox/EditInboxDetail.js";
import Domain from "../../pages/Settings/Domain.js";
import ShareMeta from "../../pages/Settings/ShareMeta.js";
import ContactInfo from "../../pages/Settings/ContactInfo.js";
import Branding from "../../pages/Settings/Branding.js";
import SiteLook from "../../pages/Settings/SiteLook.js";
import SiteContent from "../../pages/Gym/SiteContent.js";
import DeviceLimit from "../../pages/Settings/DeviceLimit.js";
import MeetingReminder from "../../pages/Settings/MeetingReminder.js";

import { coreMenu, coreMessages } from "../menus";

const core = {
  id: "core",

  messages: coreMessages,

  // react-router matches in order, so the order inside this list is kept as it always was
  routes: [
    { path: "/welcome", exact: true, component: Welcome },
    { path: "/courses", exact: true, module: "COURSES", component: AllCourses },
    { path: "/courses/add", exact: true, module: "COURSES", component: CourseBuilder },
    { path: "/courses/edit/:id", module: "COURSES", component: CourseBuilder },
    { path: "/gallery", exact: true, module: "GALLERY", component: Gallery },
    { path: "/gallery/add", module: "GALLERY", component: AddItemGallery },
    { path: "/gallery-projects", exact: true, module: "GALLERY", component: GalleryProjects },
    { path: "/resources", exact: true, module: "RESOURCES", component: Resources },
    { path: "/allInbox/add", module: "INBOX", component: AllInbox },
    { path: "/allInbox/edit/:id", module: "INBOX", component: EditInboxDetail },
    { path: "/allInbox/", exact: true, module: "INBOX", component: AllInbox },
    { path: "/news/add", exact: true, module: "NEWS", component: AddNews },
    { path: "/links/add", exact: true, component: Links },
    { path: "/notifications/add", exact: true, component: Notifications },
    { path: "/schedule", exact: true, component: Schedule },
    { path: "/settings/domain", exact: true, component: Domain },
    { path: "/settings/meeting-reminder", exact: true, module: "MEETINGS", component: MeetingReminder },
    { path: "/settings/device-limit", exact: true, component: DeviceLimit },
    { path: "/meetings", exact: true, module: "MEETINGS", component: Meetings },
    { path: "/meetings/:id/live", module: "MEETINGS", component: MeetingLive },
    { path: "/meetings/:id/attendance", module: "MEETINGS", component: MeetingAttendance },
    { path: "/billing", exact: true, component: Billing },
    { path: "/settings/share-meta", exact: true, component: ShareMeta },
    { path: "/settings/contact-info", exact: true, component: ContactInfo },
    { path: "/settings/branding", exact: true, component: Branding },
    { path: "/settings/look", exact: true, component: SiteLook },
    { path: "/settings/home-content", exact: true, component: SiteContent },
  ],

  menu: coreMenu,
};

export default core;
